import { useEffect, useMemo, useState } from "react";
import { Flex, Box, useDisclosure, Image, Divider } from "@chakra-ui/react";

import Table from "components/table";
import Topbar from "components/topbar";
import CustomSelect from "components/select";
import Searchbar from "components/searchbar";
import MainLayout from "components/mainLayout";
import InstructionModal from "components/instructionModal";
import useGetItemsToReturn from "api/queries/useGetItemsToReturn";
import { useUserContext } from "context/UserContext";
import { columns, data, sort, search } from "./data";
import { SORT_NEWEST_FIRST, SORT_OLDEST_FIRST } from "utils/constants";
import ViewModal from "./ViewModal";
import useGetItemsDonateToCharity from "api/queries/useGetItemsDonateToCharity";

const ItemsDonatedToCharity = () => {
  const { user } = useUserContext();
  const viewModal = useDisclosure();

  const instructionModal = useDisclosure();
  const [itemsData, setItemsData] = useState([]);
  const [viewData, setViewData] = useState({});

  const [sortOrder, setSortOrder] = useState(SORT_NEWEST_FIRST);
  const [searchQuery, setSearchQuery] = useState("");

  const query = useGetItemsDonateToCharity({ seller_id: user?.info?._id });

  const addActionsToRows = (rows) => {
    const dataWithActions = rows?.map((row) => {
      const action = (
        <Flex alignItems={"center"}>
          <Image
            src={require("assets/svgs/eye.svg").default}
            onClick={() => {
              viewModal?.onOpen();
              setViewData(row);
            }}
            _hover={{ cursor: "pointer" }}
          />
        </Flex>
      );
      return {
        ...row,
        action: action,
      };
    });

    return dataWithActions;
  };

// Filter + sort items based on searchQuery and sortOrder
const sortedItems = useMemo(() => {
  const raw = query?.data?.data?.products || [];

  // Filter by product title or SKU
  const filtered = raw.filter((item) => {
    if (!searchQuery) return true;

    const productTitle = item.product_title?.toLowerCase() || "";
    const sku = item.variants?.sku?.toLowerCase() || "";

    return (
      productTitle.includes(searchQuery.toLowerCase()) ||
      sku.includes(searchQuery.toLowerCase())
    );
  });

  // Sort by date_added
  const sorted = [...filtered].sort((a, b) => {
    const dateA = new Date(a.date_added);
    const dateB = new Date(b.date_added);
    return sortOrder === SORT_NEWEST_FIRST ? dateB - dateA : dateA - dateB;
  });

  return addActionsToRows(sorted);
}, [query?.data?.data?.products, sortOrder, searchQuery]);

useEffect(() => {
  setItemsData(sortedItems);
}, [sortedItems]);
  return (
    <MainLayout>
      <Box h={"100%"} minH={"100vh"} paddingBottom={20}>
        <Topbar title={"ITEMS Donated to charity"} />
        <Flex bg={"#f8fbff"} padding={4} height={"100%"} gap={2}>
          <Flex flex={1} direction={"column"} padding={4} gap={6}>
            <Flex justify={"space-between"} alignItems={"center"}>
              <Flex align={"center"}>
                <Searchbar onChange={setSearchQuery} title={"Search"} />
              </Flex>
              <CustomSelect
                label={"Sort"}
                onChange={setSortOrder}
                style={{ maxWidth: "200px" }}
                inputStyle={{
                  border: "none",
                  background: "#fff",
                  color: "#898989",
                  fontSize: "14px",
                  fontFamily: "PlusJakartaSansMedium",
                }}
              >
                <option value={SORT_NEWEST_FIRST}>Newest First</option>
                <option value={SORT_OLDEST_FIRST}>Oldest First</option>
              </CustomSelect>
            </Flex>
            <Divider />
            <Box minW={"100%"} w={"1px"} overflowX={"auto"}>
              <Table columns={columns} data={itemsData} />
            </Box>
          </Flex>
        </Flex>
      </Box>
      <ViewModal
        isOpen={viewModal?.isOpen}
        onClose={viewModal?.onClose}
        data={viewData}
      />
      <InstructionModal
        isOpen={instructionModal.isOpen}
        onClose={instructionModal.onClose}
      />
    </MainLayout>
  );
};

export default ItemsDonatedToCharity;
